import { useEffect, useState } from 'react';

import { ACCOUNT_DELETED_STORAGE } from '../../common/EsConstants';
import { useEsStrings } from '../../common/EsStrings';

// Read once, at mount: the flag outlives the full page load after the delete and nothing else.
function deletedJustNow() {
    try {
        return window.sessionStorage.getItem( ACCOUNT_DELETED_STORAGE ) === '1';
    }
    catch {
        return false;
    }
}

/**
 * The one line that says a self-delete worked, on the page it lands on. In the shell rather
 * than on the home page, because Crafter may draw the home page instead.
 * The flag is cleared as it is shown, so a reload does not say it again.
 */
export default function EsAccountDeletedNote() {
    const t = useEsStrings();
    const [ shown, setShown ] = useState( deletedJustNow );

    useEffect( () => {
        if ( !shown ) return;
        try {
            window.sessionStorage.removeItem( ACCOUNT_DELETED_STORAGE );
        }
        catch {
            // Nothing stored, nothing to clear.
        }
    }, [ shown ] );

    if ( !shown ) return null;

    return (
        <div data-testid="es-account-deleted-note" role="status"
             className="fixed inset-x-4 top-24 z-50 mx-auto flex max-w-[640px] items-center justify-between gap-4 rounded-md border border-field-edge bg-surface px-6 py-4 text-base text-body shadow-one">
            <span data-testid="es-account-deleted-note-text">
                { t( 'account-deleted-note', 'Your account has been deleted.' ) }
            </span>
            <button type="button" data-testid="es-account-deleted-note-close"
                    aria-label={ t( 'common-close', 'Close' ) }
                    onClick={ () => setShown( false ) }>
                <i className="pi pi-times" aria-hidden="true" />
            </button>
        </div>
    );
}
